import { Stack, Typography, Box } from "@mui/material"
import Image from "next/image"
import theme from "@/theme/theme"

import SmartContracts from "@/assets/images/icons/menu-smart-contracts.webp"
import Infra from "@/assets/images/icons/menu-infrastructure.webp"
import AI from "@/assets/images/icons/menu-ai.webp"
import Dev from "@/assets/images/icons/menu-dev.webp"
import GTM from "@/assets/images/icons/menu-gtm.webp"
import ZKPQC from "@/assets/images/icons/menu-zk-pqc.webp"

import arrow from "@/assets/images/icons/arrow.webp"

import mobileServicesListItemBg from "@/assets/images/servicesPage/mobile/mobileServicesListItemBg.webp"
import Link from "next/link"

const serviceKeywordStyle = {
    fontFamily: '"Funnel Display"',
    fontSize: "13px !important",
    fontWeight: 300,
    lineHeight: "108%",
};

const MobileServicesList = () => {
    return (
        <Stack width="100%" alignItems="center" gap={2}>
            <Link href="/services#smart-contracts" style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
                <Stack width="100%" height="100%" alignItems="center" gap={2} component={"div"}
                    sx={{
                        display: { xs: "flex", lg: "none" },
                        backgroundImage: `url(${mobileServicesListItemBg.src})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        paddingY: 3,
                        paddingX: 4,
                    }}>
                    <Stack width="100%" height="100%" justifyContent="space-between" gap={4}>
                        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                            <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                                <Image src={SmartContracts} alt="Smart Contracts" width={25} height={25} />
                                <Typography variant="h6" component="p" className="chno" fontWeight={500} textTransform="uppercase">
                                    Smart Contracts
                                </Typography>
                            </Stack>
                            <Stack width="fit-content" justifyContent="center" alignItems="end">
                                <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                            </Stack>
                        </Stack>
                        <Stack width="100%" direction="row" justifyContent="start" alignItems="start" gap={1} flexWrap="wrap">
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                ERC Standards
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                DApps
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Oracles
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Box sx={{ flexBasis: '100%', height: 0 }} />
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Custom Logic
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Audits Logic
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Link>
            <Link href="/services#infra-and-protocols" style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
                <Stack width="100%" height="100%" alignItems="center" gap={2} component={"div"}
                    sx={{
                        display: { xs: "flex", lg: "none" },
                        backgroundImage: `url(${mobileServicesListItemBg.src})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        paddingY: 3,
                        paddingX: 4,
                    }}>
                    <Stack width="100%" height="100%" justifyContent="space-between" gap={4}>
                        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                            <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                                <Image src={Infra} alt="Infra & Protocols" width={25} height={25} />
                                <Typography variant="h6" component="p" className="chno" fontWeight={500} textTransform="uppercase">
                                    Infra & Protocols
                                </Typography>
                            </Stack>
                            <Stack width="fit-content" justifyContent="center" alignItems="end">
                                <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                            </Stack>
                        </Stack>
                        <Stack width="100%" direction="row" justifyContent="start" alignItems="start" gap={1} flexWrap="wrap">
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Layer Setup
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Chain Infra
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Box sx={{ flexBasis: '100%', height: 0 }} />
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Tooling
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                DevOps Pipelines
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Link>
            <Link href="/services#ai-systems" style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
                <Stack width="100%" height="100%" alignItems="center" gap={2} component={"div"}
                    sx={{
                        display: { xs: "flex", lg: "none" },
                        backgroundImage: `url(${mobileServicesListItemBg.src})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        paddingY: 3,
                        paddingX: 4,
                    }}>
                    <Stack width="100%" height="100%" justifyContent="space-between" gap={4}>
                        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                            <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                                <Image src={AI} alt="AI Systems" width={25} height={25} />
                                <Typography variant="h6" component="p" className="chno" fontWeight={500} textTransform="uppercase">
                                    AI Systems
                                </Typography>
                            </Stack>
                            <Stack width="fit-content" justifyContent="center" alignItems="end">
                                <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                            </Stack>
                        </Stack>
                        <Stack width="100%" direction="row" justifyContent="start" alignItems="start" gap={1} flexWrap="wrap">
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                LLM Agents
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Prediction Models
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Box sx={{ flexBasis: '100%', height: 0 }} />
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                GenAI Content
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                AI SDKs
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Link>
            <Link href="/services#product-dev" style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
                <Stack width="100%" height="100%" alignItems="center" gap={2} component={"div"}
                    sx={{
                        display: { xs: "flex", lg: "none" },
                        backgroundImage: `url(${mobileServicesListItemBg.src})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        paddingY: 3,
                        paddingX: 4,
                    }}>
                    <Stack width="100%" height="100%" justifyContent="space-between" gap={4}>
                        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                            <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                                <Image src={Dev} alt="Product Dev" width={25} height={25} />
                                <Typography variant="h6" component="p" className="chno" fontWeight={500} textTransform="uppercase">
                                    Product Dev
                                </Typography>
                            </Stack>
                            <Stack width="fit-content" justifyContent="center" alignItems="end">
                                <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                            </Stack>
                        </Stack>
                        <Stack width="100%" direction="row" justifyContent="start" alignItems="start" gap={1} flexWrap="wrap">
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                UX Design
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Backend
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                DB
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Box sx={{ flexBasis: '100%', height: 0 }} />
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                App Dev
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                APIs
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Link>
            <Link href="/services#zk-and-pqc" style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
                <Stack width="100%" height="100%" alignItems="center" gap={2} component={"div"}
                    sx={{
                        display: { xs: "flex", lg: "none" },
                        backgroundImage: `url(${mobileServicesListItemBg.src})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        paddingY: 3,
                        paddingX: 4,
                    }}>
                    <Stack width="100%" height="100%" justifyContent="space-between" gap={4}>
                        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                            <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                                <Image src={ZKPQC} alt="ZK & PQC" width={25} height={25} />
                                <Typography variant="h6" component="p" className="chno" fontWeight={500} textTransform="uppercase">
                                    ZK AND PQC
                                </Typography>
                            </Stack>
                            <Stack width="fit-content" justifyContent="center" alignItems="end">
                                <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                            </Stack>
                        </Stack>
                        <Stack width="100%" direction="row" justifyContent="start" alignItems="start" gap={0.8} flexWrap="wrap">
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Cybersecurity Audits
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Cryptography Models
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Box sx={{ flexBasis: '100%', height: 0 }} />
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                ZK Proof
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Post Quantum Migration
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Link>
            <Link href="/services#gtm-and-legal" style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
                <Stack width="100%" height="100%" alignItems="center" gap={2} component={"div"}
                    sx={{
                        display: { xs: "flex", lg: "none" },
                        backgroundImage: `url(${mobileServicesListItemBg.src})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        paddingY: 3,
                        paddingX: 4,
                    }}>
                    <Stack width="100%" height="100%" justifyContent="space-between" gap={4}>
                        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                            <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                                <Image src={GTM} alt="GTM & Legal" width={25} height={25} />
                                <Typography variant="h6" component="p" className="chno" fontWeight={500} textTransform="uppercase">
                                    GTM & Legal
                                </Typography>
                            </Stack>
                            <Stack width="fit-content" justifyContent="center" alignItems="end">
                                <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                            </Stack>
                        </Stack>
                        <Stack width="100%" direction="row" justifyContent="start" alignItems="start" gap={1} flexWrap="wrap">
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                MVP Validation
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Token Legal
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Box sx={{ flexBasis: '100%', height: 0 }} />
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                Compliance
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                /
                            </Typography>
                            <Typography variant="body1" component="p" color={theme.palette.text.secondary} sx={serviceKeywordStyle}>
                                EMEA Strategy
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Link>
        </Stack>
    )
}

export default MobileServicesList;